import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { DirtyProgramCompletion } from '../ProgramCompletion/ProgramCompletion';
import { DEFAULT_OPTION } from '../Fields/ProgramSelectField/ProgramSelectField';

interface ProgramDeleteWarningProps extends DirtyProgramCompletion {}

const ProgramDeleteWarning: React.FC<ProgramDeleteWarningProps> = ({
  programName,
  academicPartnerName,
}) => {
  const CONTENT_TEXT =
    programName !== DEFAULT_OPTION.value && academicPartnerName !== DEFAULT_OPTION.value
      ? `The record for ${programName} at ${academicPartnerName} will be deleted. Do you want to continue?`
      : 'The record will be deleted. Do you want to continue?';

  return (
    <Typography variant='body1' data-testid='program-delete-warning'>
      {CONTENT_TEXT}
    </Typography>
  );
};

export default ProgramDeleteWarning;
